// Free Policy Review — client helpers. Submissions are a PRIVATE document intake
// and are intentionally separate from the Constant Contact lead-magnet flow.

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const POLICY_REVIEW_CONSENT_TEXT =
  "I confirm that I am authorized to submit this document and consent to Legacy Life & Retirement reviewing the information for educational purposes. I understand this request does not create an insurance, legal, tax, or advisory relationship.";

export const POLICY_REVIEW_MARKETING_TEXT =
  "Yes, I would also like to receive educational emails from Legacy Life & Retirement. I can unsubscribe at any time.";

export const MAX_FILE_BYTES = 10 * 1024 * 1024; // 10 MB
export const ALLOWED_EXTENSIONS = ["pdf", "doc", "docx", "jpg", "jpeg", "png"];
export const ALLOWED_ACCEPT = ".pdf,.doc,.docx,.jpg,.jpeg,.png";

export function formatBytes(bytes) {
  if (!bytes) return "0 KB";
  const mb = bytes / (1024 * 1024);
  if (mb >= 1) return `${mb.toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

export function validatePolicyFile(file) {
  if (!file) return null;
  const ext = file.name.includes(".") ? file.name.split(".").pop().toLowerCase() : "";
  if (!ALLOWED_EXTENSIONS.includes(ext)) {
    return "Unsupported file type. Please upload a PDF, DOC, DOCX, JPG, or PNG.";
  }
  if (file.size > MAX_FILE_BYTES) {
    return "The file is larger than the 10 MB limit.";
  }
  return null;
}

export function validatePolicyForm({ firstName, lastName, email, consent, file }) {
  const errors = {};
  if (!firstName) errors.firstName = "Please enter your first name.";
  if (!lastName) errors.lastName = "Please enter your last name.";
  if (!email) {
    errors.email = "Please enter your email address.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.email = "Please enter a valid email address.";
  }
  const fileError = validatePolicyFile(file);
  if (fileError) errors.file = fileError;
  if (!consent) errors.consent = "Please confirm the authorization and consent statement.";
  return errors;
}

export async function submitPolicyReview(fields, file) {
  const form = new FormData();
  form.append("first_name", fields.firstName);
  form.append("last_name", fields.lastName);
  form.append("email", fields.email);
  form.append("phone", fields.phone || "");
  form.append("insurance_company", fields.insuranceCompany || "");
  form.append("message", fields.message || "");
  form.append("consent", fields.consent ? "true" : "false");
  form.append("marketing_opt_in", fields.marketingOptIn ? "true" : "false");
  form.append("form_source", "policy-review");
  form.append("idempotency_key", fields.idempotencyKey || "");
  form.append("company", fields.company || ""); // honeypot
  if (file) form.append("document", file);

  try {
    const res = await fetch(`${BACKEND}/api/policy-review`, { method: "POST", body: form });
    return await res
      .json()
      .catch(() => ({ status: "server_error", message: "Something went wrong. Please try again." }));
  } catch {
    return { status: "server_error", message: "We couldn't reach the server. Please try again." };
  }
}
